import {Injectable} from "@angular/core";
import {ISystemConfiguration} from "../interfaces/interfaces";
import {HttpObservable, HttpWrapper} from "../../http-helpers/http.wrapper";

@Injectable({
  providedIn: 'root'
})
export class SystemConfigurationProxy {
  constructor(private httpWrapper: HttpWrapper) {
  }

  public GetSystemConfiguration(): HttpObservable<ISystemConfiguration> {
    return this.httpWrapper.get("PatientPortalConfiguration", "GetSystemConfiguration", null, null);
  }

  public GetPreLoginSystemConfiguration(): HttpObservable<ISystemConfiguration> {
    return this.httpWrapper.getAnon("PatientPortalConfiguration", "GetPreLoginSystemConfiguration", null, null);
  }
}
